<div class="example-container">
  <div class="example-table-container">
    <table mat-table matSort [dataSource]="dataSource"> @if (selectable) {
      <ng-container matColumnDef="select">
      </ng-container>
    }
    @for (col of tableCols; track col; let i = $index) {
      <ng-container [matColumnDef]="col.key">
        <th class="table-header" mat-header-cell *matHeaderCellDef> {{ tableCols[i]['display'] }} </th>
        <td mat-cell [ngStyle]="col.style" *matCellDef="let element">
          <!-- Checking if it's a normal column or column with specific config -->
          @if (!col.config) {
            {{ element[col.key] }}
          } @else {
            @if (col.config?.clickableCell) {
              <a (click)="handleClickAction(element)"
              class="clickable-cell"> {{ element[col.key] }} </a>
            }
            <!-- if this attribute has an image to display -->
            @if (col.config?.hasImage) {
              <a
                (click)="handleClickAction(element)" class="clickable-cell"> <img class="table-img"
              [src]="generateGravatarUrl(col.key)" />{{ element[col.key] }} </a>
            }
            <!-- if this attribute is a date, we will format it depending on format value in config object -->
            @if (col.config?.isDate) {
              {{ element[col.key] * 1000 | date : col.config?.format }}
            }
            @if (col.config?.isToggle) {
              <mat-slide-toggle id="genericTableToggle-{{col.key}}-{{element.id || element[tableCols[0]?.key]}}" [checked]="element[col.key]"></mat-slide-toggle>
            }
          }  </td>
        </ng-container>
      }
      <tr class="row-table-ihnor" mat-header-row *matHeaderRowDef="keys"></tr>
      <tr mat-row *matRowDef="let row; columns: keys"></tr>
      <tr *matNoDataRow>
        <td class="no-result-cell" colspan="10">
          <div class="no-result-div">
            <div class="no-result-title">Oops, No Records Found</div>
            @if (searchTerm) {
              <div class="no-result-description"> We are unable to find the record you are looking for.
              Try another search term. </div>
            }
          </div>
        </td>
      </tr>
    </table>
  </div> @if (!preview) {
  <mat-paginator [pageSizeOptions]="paginationValues"
  aria-label="Select page of records" class="roboto"></mat-paginator>
}
</div>
